// extracted by mini-css-extract-plugin
export default {"metrics":"metrics_metrics__zLuxy"};